<ami-dialog-message [setting]="message"></ami-dialog-message>

<pg-provider-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-provider-create>

<pg-provider-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-provider-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
